import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-c-one-two',
  templateUrl: './c-one-two.component.html',
  styleUrls: ['./c-one-two.component.scss']
})
export class COneTwoComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5 ){
      this.showSideMenu=true;
      this.fullWidth=false;
      this.showHeading = true;
    }
    else if(url.length === 6){
      this.showSideMenu=false;
      this.fullWidth=false;
      this.showHeading = false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
